import React from 'react';
import '../../components/css/popupstyle.css';
import DeleteIcon from '../.././components/css/dark/img/delete.svg';
import EditIcon from '../.././components/css/dark/img/edit2.svg';
import { userService } from '../../_services';
import $ from 'jquery';

class CreateWholesaler extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: '',
            loader: false,
            btnLoader: false,
            userdata: JSON.parse(localStorage.getItem('user')),
            commissionMilestone: [],
            hubId: '',
            whName: '',
            hubError: ''
        }
    }  
    componentDidMount() {
        $(".yes-rule").prop("checked", true);
        $(".no-triprx").prop("checked", true);        
        $(".no-sequence").prop("checked", true);
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
    }
    addMilestone = () => {
        let randomId = Math.floor(10000 + Math.random() * 90000);
        let newIndex = this.state.commissionMilestone.length;
        let milestone = this.state.commissionMilestone;
        let newMilestone = {
            msid: '',
            from: '',
            to: '',
            commission: '',
            isineditedmode: true,
            id: randomId
        };
        milestone.push(newMilestone);
        this.setState({ commissionMilestone: milestone, error: '' });
        setTimeout(function() {
            $('input[textindex=' + newIndex + ']').focus();
        }, 100);
    }    
    saveData = (e) => {

        // get input field values
        let currentIndex = e.target.getAttribute('dataindex');
        let htmlprefix = $(e.target).parents('.milestoneData');
        let milestoneIndex = htmlprefix.find('.first-one').text();
        let from = htmlprefix.find('input[name = "from"]').val();
        let to = htmlprefix.find('input[name = "to"]').val();
        let commission = htmlprefix.find('input[name = "mComm"]').val();
        let wholeNumber = /^(?:0|(?:[1-9](?:\d{0,2}(?:,\d{3})+|\d*)))$/;
        let milestone = this.state.commissionMilestone;

        if (!userService.Check_Null_Empty(from) && !userService.Check_Null_Empty(to) && !userService.Check_Null_Empty(commission) && userService.validateCurrency(commission)) {
            // validate all fields
            if (wholeNumber.test(from)) {
                if (wholeNumber.test(to)) {
                    if (commission > 10) {
                        this.setState({ error: 'Commission should not be more than 10' });
                        return false;
                    } else {
                        // to field value is greater than from
                        if (parseInt(to) > parseInt(from)) {
                            milestone[currentIndex].msid = milestoneIndex;
                            milestone[currentIndex].from = from;
                            milestone[currentIndex].to = to;
                            milestone[currentIndex].commission = commission;
                            milestone[currentIndex].isineditedmode = false;
                            this.setState({ commissionMilestone: milestone, error: '' });
                        } else {
                            this.setState({ error: 'The milestone To fields should be greater than the From fields' });
                            return false;
                        }
                    }
                } else {
                    this.setState({ error: 'Invalid to value' });
                    return false;
                }
            } else {
                this.setState({ error: 'Invalid from value' });
                return false;
            }
        }
        else {
            this.setState({ error: 'All fields are required and commission should be a numeric value e.g. 0.5 or 1.5' });
            return false;
        }
        return true;
    }
    handleEdit = (e) => {

        // current index
        let currentIndex = e.target.getAttribute('dataindex');

        let milestone = this.state.commissionMilestone;
        milestone[currentIndex].isineditedmode = true;
        this.setState({ commissionMilestone: milestone });
    }
    handleSaveSubmit = (e) => {

        // disable submit
        $(e.target).attr("disabled", true);
        this.setState({ loader: true });
        
        // get input field values
        let htmlprefix = $(e.target).parents('.wholesaler-section');
        let whid = '-1'; 
        let roleName = this.state.userdata.paramsname;
        let roleType = this.state.userdata.userrole;
        let whname = this.state.whName;
        let hubSpotId = this.state.hubId;
        let whemail = htmlprefix.find('input[name = "email"]').val();
        let whcontact = htmlprefix.find('input[name = "contactName"]').val();
        let whcomm = htmlprefix.find('input[name = "wholesalerCommission"]').val();
        let isruled;
        if (htmlprefix.find('input[name = "rules"]:checked').val() == 'yes') {
            isruled = true;
        } else {
            isruled = false;
        }
        let isTriprx = $('#triprx').prop('checked');
        let isGlicEnable = $('#enableGlic').prop('checked');
        let isdashboardneeded = $('#createDashboard').prop('checked');
        let iscustomgroup;
        if (htmlprefix.find('input[name = "customGroup"]:checked').val() == 'yes') {
            iscustomgroup = true;
        } else {
            iscustomgroup = false;
        }
        let pattern = /^(0|[1-9][0-9]*)$/;
        let gnprefix = '';
        let msjson = this.state.commissionMilestone;
        let jsonLength = parseInt(msjson.length) -1; 
        for (let i = 0; i < msjson.length; i++) {
            if (msjson[i].isineditedmode == true) {
                this.saveData(e);
            } 
        }
        if (!userService.Check_Null_Empty(whname) && !userService.Check_Null_Empty(whcontact) && !userService.Check_Null_Empty(whemail) && !userService.Check_Null_Empty(whcomm) && userService.validateCurrency(whcomm)) {
            if (whcomm > 10) {
                this.setState({ error: 'Commission should not be more than 10', loader: false });
                $(e.target).attr("disabled", false);
            } else {
                if (!userService.ValidateEmail(whemail)) {
                    this.setState({ error: 'Enter a valid email ID', loader: false });
                    $(e.target).attr("disabled", false);
                } else {
                    if (pattern.test(whcontact)) {
                        this.setState({ error: 'Contact name must be alpha numeric', loader: false });
                        $(e.target).attr("disabled", false);
                    } else {

                        if (parseInt(msjson.length) == 0) {
                            if (isruled == true) {
                                this.setState({ error: 'Add at least two milestones', loader: false });
                                $(e.target).attr("disabled", false);
                            } else {
                                this.addNewWholesaler(whid, roleName, roleType, whname, whemail, whcontact, whcomm, isruled, isGlicEnable, isdashboardneeded, iscustomgroup, gnprefix, msjson, hubSpotId, isTriprx);
                            }
                        } else {

                            let IsError = 0;
                            let milestoneOpen = false;

                            let jsonLength = parseInt(msjson.length) - 1;
                            for (let i = 0; i < msjson.length; i++) {
                                if (msjson[i].isineditedmode == true) {
                                    this.setState({ error: 'Save all milestones', loader: false, btnLoader: false });
                                    $(e.target).attr("disabled", false);
                                    milestoneOpen = true;
                                }
                            }

                            if (milestoneOpen == false) {

                                // sort our milestone using from values
                                msjson.sort(function (a, b) { return a.from - b.from });

                                // milestone must start from zero
                                if (parseInt(msjson[0].from) == 0) {

                                    // from field value is equal to prev to field
                                    for (let i = 0; i < msjson.length; i++) {

                                        if (parseInt(msjson.length) == 1) {

                                            // msjon length 1 show error
                                            IsError = 1;

                                        } else {

                                            if (i == parseInt(msjson.length) - 1) {
                                                break;
                                            } else {

                                                // from field value is equal to prev to field
                                                if (parseInt(msjson[i + 1].from) == msjson[i].to) {

                                                    if (parseInt(msjson[jsonLength].to) == 999999) {
                                                        continue;
                                                    } else {
                                                        IsError = 2;
                                                    }

                                                } else {
                                                    IsError = 3;
                                                }
                                            }
                                        }
                                    }

                                    if (IsError == 0) {
                                        this.addNewWholesaler(whid, roleName, roleType, whname, whemail, whcontact, whcomm, isruled, isGlicEnable, isdashboardneeded, iscustomgroup, gnprefix, msjson, hubSpotId, isTriprx);

                                    } else if (IsError == 1) {

                                        this.setState({ error: 'Add at least two milestones', loader: false });
                                        $(e.target).attr("disabled", false);

                                    } else if (IsError == 2) {

                                        this.setState({ error: 'The last milestone To field should be 999999', loader: false });
                                        $(e.target).attr("disabled", false);

                                    } else if (IsError == 3) {

                                        this.setState({ error: 'The From field should equal the previous To field in each milestone (not including the first)', loader: false });
                                        $(e.target).attr("disabled", false);

                                    }

                                } else {
                                    this.setState({ error: 'The lowest value for the From field must be 0', loader: false });
                                    $(e.target).attr("disabled", false);
                                }
                            }
                        }
                    }
                }
            }
        } else {
            this.setState({ error: 'All fields are required and commission should be a numeric value e.g. 0.5 or 1.5', loader: false });
            $(e.target).attr("disabled", false);
        }        
    }
    addNewWholesaler(whid, roleName, roleType, whname, whemail, whcontact, whcomm, isruled, isGlicEnable, isdashboardneeded, iscustomgroup, gnprefix, msjson, companyid, isTriprx) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'MSJsonHeader': JSON.stringify( msjson )},
                body: JSON.stringify({ whid, roleName, roleType, whname, whemail, whcontact, whcomm, isruled, isGlicEnable, isdashboardneeded, iscustomgroup, gnprefix, companyid, isTriprx})
            };
            return fetch(`/api/admin/AddNewWhDetail`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata[0].code === "1") {
                            this.setState({
                                error: apidata[0].statusMessage
                                });
                            setTimeout(() => {
                                this.handleCancel();
                            }, 1800);
                        } else {
                            this.setState({ error: apidata[0].statusMessage, loader: false });
                            $('.save').attr("disabled", false);                            
                        }
                    }
                    catch (error) {
                        this.setState({ error: 'Something went wrong. Please try later.', loader: false });
                        $('.save').attr("disabled", false);                            
                    }
                });
        }
        catch (error) {
        }

    }
    handleResponse(response) {
        return response.text().then(text => {
            try {
                const data = text && JSON.parse(text);
                return data;
            }
            catch (error) {
                const data = [];
                return data;
            }
        });
    }
    handleCancel = () => {
        this.props.closeAddWholesalerPopup();
        this.props.openWholesalerPopup(this.props.activePagin);
    }
    cancelList = (e) => {
        let x = this.state.commissionMilestone;
        let indexedvalue = x[e.target.getAttribute('dataindex')];
        
        if (this.validation(indexedvalue.from, indexedvalue.to, indexedvalue.commission)) {
            x.forEach(function (a, index) {
                if (index == parseInt(e.target.getAttribute('dataindex'))) {
                    a.isineditedmode = false;
                }
            });
            this.setState({ commissionMilestone: x, error: '' });
        } else {
            x.splice(e.target.getAttribute('dataindex'), 1);
            this.setState({ commissionMilestone: x, error: '' });
        }
    }
    validation(from, to, commission) {
        if (!userService.Check_Null_Empty(from) && !userService.Check_Null_Empty(to) && !userService.Check_Null_Empty(commission) && userService.validateCurrency(commission)) {
            return true;
        } else {
            return false;
        }
    }
    deleteMilestone = (e) => {
        let currentIndex = e.target.getAttribute('dataindex');
        let x = this.state.commissionMilestone;
        x.splice(currentIndex, 1);
        this.setState({ commissionMilestone: x, error: '' });
    }
    hubId = (e) => {
        this.setState({ loader: true });
        $('.hub-id').attr("disabled", true);
        let roleName = this.state.userdata.paramsname;
        let roleType = this.state.userdata.userrole; 
        let hubId = this.state.hubId;
        if (!userService.Check_Null_Empty(hubId)) {
            this.createHubId(roleName, roleType, hubId);
        } else {
            this.setState({ hubError: 'Enter a Hubspot Company ID', loader: false });
            $('.hub-id').attr("disabled", false);
        }
    }
    createHubId = (roleName, roleType, hubspotid) => {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json'},
                body: JSON.stringify({ roleName, roleType, hubspotid })
            };
            return fetch(`/api/admin/CompanyInfo`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length > 0) {
                            if (apidata[0].status == "User Available") {
                                setTimeout(() => {
                                    $('.hub-section').hide();
                                    $('.popup_inner').removeClass('add-hub');
                                    $('.login-hub-section').show();
                                    $('input[name="wholesalerName"]').attr('disabled', 'true');
                                    this.setState({ whName: apidata[0].whname, loader: false });
                                }, 1800);
                            } else {
                                this.setState({ hubError: apidata[0].status, loader: false });
                                $('.hub-id').attr("disabled", false);
                            }


                        } else {

                            this.setState({
                                hubError: 'Whoops, something went wrong. Please try again',
                                loader: false
                            });
                        }

                    }
                    catch (error) {
                        this.setState({ hubError: error, loader: false });
                        $('.hub-id').attr("disabled", false);
                    }
                });
        }
        catch (error) {

        }
    }
    handleHubId = (e) => {
        let hubId = e.target.value;
        if (hubId.match(/^[0-9]+$/)) {
            this.setState({ hubId: e.target.value, hubError: '' });
            $('.hub-id').attr("disabled", false);
        } else if (hubId =='') {
            this.setState({ hubId: e.target.value, hubError: '', loader: false });
            $('.hub-id').attr("disabled", false);
        } else {
            this.setState({ hubId: e.target.value, hubError: 'Enter a valid Hubspot Company ID', loader: false });
            $('.hub-id').attr("disabled", true);
        }
    }
    labelClick = (e) => {
        $(e.target).parents().children('input').prop("checked", true);
    }
    commissionLabel = (e) => {
        if ($(e.target).parents().children('input').attr('value') == 'yes') {
            $(e.target).parents().children('input').prop("checked", true);
            $(".override-section").show();
        } else {
            $(e.target).parents().children('input').prop("checked", true);
            $(".override-section").hide();
        }
    }
    render() {
        const { loader, error, hubError } = this.state;
       return (
            <div className='popup mfp-zoom-in override-content admin-popup'>
                <div className='popup_inner manage-distributor-design add-hub'>

                   <h1>{this.state.whName == '' ? this.props.titleText : this.state.whName }<button onClick={this.handleCancel}>X</button></h1>
                   <div className="wholesaler-section">
                       <form className="add-wh-form">
                            <div className="hub-section">
                               {loader &&
                                   <div className="theme-loader"></div>
                               }
                               <label>Please Enter Hubspot Company Id</label>
                               <input type="text" className="form-control" name="hubId" onChange={this.handleHubId} value={this.state.hubId} />
                                <input type="button" onClick={this.hubId} className="btn hub-id" value="Submit" />
                                <input type="button" onClick={this.handleCancel} className="btn cancel" value="Cancel" />
                               {hubError &&
                                   <div className={'alert alert-danger'}>{hubError}</div>
                               }
                            </div>
                           <div className="login-hub-section">
                               <div className="scrollable">
                                <div className="left-side">
                                   <label>Hubspot Company Id</label>
                                   <input type="text" className="form-control" name="wholesalerName" value={this.state.hubId} />
                                </div>
                                <div className="right-side">
                                    <label>Commission</label>
                                    <input type="text" className="form-control" name="wholesalerCommission" />
                                </div>
                                <div className="left-side">
                                    <label>Contact Name</label>
                                    <input type="text" className="form-control" name="contactName" />
                                </div>
                                <div className="right-side">
                                    <label>Email</label>
                                    <input type="email" required className="form-control" name="email" />
                                </div>
                               <div className="change-section">
                                   <div className="col-lg-3">
                                       <label>Commission Rules</label>
                                       <div className="same">
                                           <input type="radio" name="rules" value="yes" onClick={this.commissionLabel} className="form-control yes-rule radiobox" />
                                           <span onClick={this.commissionLabel}>Yes</span>
                                       </div>
                                       <div className="same">
                                           <input type="radio" name="rules" value="no" onClick={this.commissionLabel} className="form-control no-rule radiobox" />
                                           <span onClick={this.commissionLabel}>No</span>
                                       </div>                                       
                                   </div>
                                   <div className="col-lg-3">
                                       <label>Enable GlicRx</label>
                                       <div className="add-glic">
                                           <div className="create-dash-glic">
                                               <input type="checkbox" id="enableGlic" name="enableGlic" className="form-control checkbox" />
                                               <label for="enableGlic">&nbsp;</label>
                                           </div>
                                       </div>
                                   </div>
                                   <div className="col-lg-3">
                                       <label>Enable TripRx</label>
                                       <div className="add-glic">
                                           <div className="create-dash-glic">
                                                <input type="checkbox" id="triprx" name="triprx" className="form-control checkbox" /> 
                                               <label for="triprx">&nbsp;</label>
                                           </div>
                                       </div>
                                   </div>
                                   <div className="col-lg-3">
                                       <label>Custom Group Sequence?</label>
                                       <div className="same">
                                           <input type="radio" name="customGroup" value="yes" className="form-control sequence radiobox" />
                                           <span onClick={this.labelClick}>Yes</span>
                                       </div>
                                       <div className="same">
                                           <input type="radio" name="customGroup" value="no" className="form-control no-sequence radiobox" />
                                           <span onClick={this.labelClick}>No</span>
                                       </div>
                                   </div>
                               </div>
                                <div className="override-section milestone differ">
                                    {
                                        this.state.commissionMilestone != null && this.state.commissionMilestone.length > 0 ?
                                           <div className="right">
                                               <h2 className="adding-override">Commission Milestones</h2>
                                                <a href="javascript:void('0')" className="add-new" onClick={this.addMilestone}>Add Milestone</a>
                                                <table>
                                                    <thead>
                                                        <tr className="header Sub">
                                                            <th className="first-one">Milestone</th>
                                                            <th className="second-one">From</th>
                                                            <th className="third-one">To</th>
                                                            <th className="fourth-one">Commission</th>
                                                            <th className="fifth-one">Actions</th>
                                                        </tr>
                                                    </thead>
                                                       <tbody style={{ overflow: 'unset', height: 'auto' }}>
                                                        {
                                                            this.state.commissionMilestone.map((item, innerIndex) => {
                                                                return (
                                                                    item.isineditedmode ?
                                                                        <tr className="milestoneData">
                                                                            <td className="first-one">
                                                                                <div className="formgroup" key={item.id}>
                                                                                    <label>{innerIndex + 1}</label>
                                                                                </div>
                                                                            </td>
                                                                            <td className="second-one">
                                                                                <div className="formgroup" key={item.id}>
                                                                                    <input type="text" textindex={innerIndex} defaultValue={item.from} className="form-control" name="from" />
                                                                                </div>
                                                                            </td>
                                                                            <td className="third-one">
                                                                                <div className="formgroup" key={item.id}>
                                                                                    <input type="text" defaultValue={item.to} className="form-control" name="to" />
                                                                                </div>
                                                                            </td>
                                                                            <td className="fourth-one">
                                                                                <div className="formgroup" key={item.id}>
                                                                                    <input type="text" defaultValue={item.commission} className="form-control" name="mComm" />
                                                                                </div>
                                                                            </td>
                                                                            <td className="fifth-one">
                                                                                <input type="button" dataindex={innerIndex} className="btn" onClick={this.saveData} value="Save" />
                                                                                <input type="button" dataindex={innerIndex} onClick={this.cancelList} className="btn cancel" value="Cancel" />
                                                                            </td>
                                                                        </tr> :
                                                                        <tr className="milestoneData editable">
                                                                            <td className="first-one">
                                                                                <div className="formgroup">
                                                                                    <label>{innerIndex + 1}</label>
                                                                                </div>
                                                                            </td>
                                                                            <td className="second-one">
                                                                                <div className="formgroup">
                                                                                    <label>{item.from}</label>
                                                                                </div>
                                                                            </td>
                                                                            <td className="third-one">
                                                                                <div className="formgroup">
                                                                                    <label>{item.to}</label>
                                                                                </div>
                                                                            </td>
                                                                            <td className="fourth-one">
                                                                                <div className="formgroup">
                                                                                    <label>{item.commission}</label>
                                                                                </div>
                                                                            </td>
                                                                            <td className="fifth-one">
                                                                                <img onClick={this.handleEdit} dataindex={innerIndex} src={EditIcon} className="editIcon" alt="editIcon" />
                                                                                <img src={DeleteIcon} dataindex={innerIndex} onClick={this.deleteMilestone} className="deleteIcon" alt="deleteIcon" />
                                                                            </td>
                                                                        </tr>
                                                                )
                                                            })
                                                        }

                                                    </tbody>
                                                </table>
                                            </div> :
                                            <div className="right">
                                                <div className="list-section">
                                                    <h2>Commission Milestones</h2>
                                                    <span className="no-override">No milestones added yet</span>
                                                    <a href="javascript:void('0')" className="add-new some" onClick={this.addMilestone}>Add Milestone</a>
                                                </div>
                                            </div>
                                    }
                                   </div>
                               </div>
                                <div className="button-section">
                                   <div className="create-dash">
                                       <input type="checkbox" id="createDashboard" checked="checked" readOnly name="createDashboard" className="form-control checkbox" />
                                        <label for="createDashboard">Create Wholesaler Dashboard</label>
                                    </div>
                                    {loader &&
                                        <div className="theme-loader animated-loader"></div>
                                    }
                                    <input type="button" onClick={this.handleSaveSubmit} className={loader ? 'btn save animated-btn' : 'btn save'} value="Create" />
                                    <input type="button" onClick={this.handleCancel} className="btn cancel" value="Cancel" />
                                    {error &&
                                        <div className={'alert alert-danger'}>{error}</div>
                                    }
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        )
    }
}

export default CreateWholesaler;